import { TeamsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { teamsKeys } from 'app/queries/teams/teamsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof teamsKeys.availableMembersByTeam>>;

export const createFetchTeamAvailableMembersQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationRoleId }], signal }: TParams) =>
    call(() => cancelOnSignal(TeamsService.findAvailableMembers({ organizationRoleId }), signal));
